/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import cls from 'classnames';

import styles from './LinkBase.scss';

export type LinkBaseProps = React.PropsWithChildren<
  React.ComponentPropsWithoutRef<'a'> & {
    /** Место для перехода React Router */
    to?: string;

    /** Значение для сохранения истории или её замены */
    replace?: boolean;

    /** Свой компонент для перехода */
    component?: React.ElementType;

    /** Дополнительные дата-локаторы */
    specificLocators?: string | string[];
  }
>;

const LinkBaseComponent = forwardRef<HTMLAnchorElement, LinkBaseProps>((props, ref) => {
  const {
    target: forwardedTarget,
    rel: forwardedRel,
    href,
    to,
    replace,
    children,
    component: Component,
    className,
    specificLocators,
    ...forwardedProps
  } = props;

  const rel =
    forwardedTarget === '_blank' && forwardedRel === undefined
      ? 'noopener noreferrer'
      : forwardedRel;

  const baseProps = {
    ref,
    className: cls(styles.root, className),
    'data-locator': specificLocators,
  };

  if (Component) {
    return (
      <Component
        to={to}
        href={href}
        target={forwardedTarget}
        rel={rel}
        {...forwardedProps}
        {...baseProps}
      >
        {children}
      </Component>
    );
  }

  if (to) {
    return (
      <RouterLink to={to} replace={replace} {...forwardedProps} {...baseProps}>
        {children}
      </RouterLink>
    );
  }

  return (
    <a href={href} rel={rel} target={forwardedTarget} {...forwardedProps} {...baseProps}>
      {children}
    </a>
  );
});

export const LinkBase = memo(LinkBaseComponent);
